import { getCSRCookieData } from '@/app/api/CSR/getCSRCookieData'
import buildTraceSampleRate from './buildTraceSampleRate'
import denyUrls from './denyUrls'
import { Enviroments } from './entities'
import ignoreErrors from './ignoreErrors'

import type { Integration, Options } from '@sentry/core'
import { BrowserOptions, EdgeOptions, NodeOptions } from '@sentry/nextjs'
import beforeSend from './beforeSend'
import buildBeforeSendTransaction from './beforeSendTransaction/buildBeforeSendTransaction'

type SentryInitParams = Options | BrowserOptions | NodeOptions | EdgeOptions

const buildSentryConfig = (
  log: () => void,
  integrations: Integration[] = []
): SentryInitParams => {
  log?.()

  const clientId = getCSRCookieData('_IL-clientId') ?? ''
  const suffix = clientId?.length > 0 ? `-${clientId}` : ''
  const environment = `${process.env.NEXT_PUBLIC_ENV}${suffix}`

  const BaseOptions: SentryInitParams = {
    dsn: 'https://2b0288498ac04c26a2edd4aff4bf1c64@o4504645373001728.ingest.us.sentry.io/4505556895596544',
    ignoreErrors,
    environment,
    denyUrls,
    replaysOnErrorSampleRate: 0.1,
    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: buildTraceSampleRate(
      process.env.NEXT_PUBLIC_ENV as Enviroments
    ),
    debug: false,
    beforeSend: beforeSend,
    beforeSendTransaction: buildBeforeSendTransaction,
    integrations,
  }

  return BaseOptions
}

export default buildSentryConfig
